export default __webpack_public_path__ + "static/media/page.9fb964a0.jpg";